import {
  pollingResponseTransformer,
  InitiateAsyncTaskResponse,
  initiateAsyncTaskResponseTransformer,
  UseAsyncDownloadTask,
} from 'src/utilities/useAsyncDownloadTask/useAsyncDownloadTask.utils';
import { useAsyncTask } from 'src/utilities/useAsyncTask';

export const useAsyncDownloadTask = (): UseAsyncDownloadTask => {
  const { startAsyncTask, ...asyncTaskProps } = useAsyncTask();

  async function startAsyncDownloadTask(
    asyncTaskFunction: () => Promise<InitiateAsyncTaskResponse>
  ) {
    return startAsyncTask(
      async () => {
        const response = await asyncTaskFunction();
        return initiateAsyncTaskResponseTransformer(response);
      },
      {
        pollingResponseTransformer,
      }
    );
  }

  return {
    ...asyncTaskProps,
    startAsyncTask: startAsyncDownloadTask,
  };
};
